import { Clock, Pencil, Ban, FileEdit, CheckCircle2, EyeOff } from "lucide-react";

const MAP = {
  draft: { label: "Draft", cls: "bg-slate-500/15 text-slate-300 border-slate-500/30", Icon: FileEdit },
  pending: { label: "Pending Review", cls: "bg-amber-500/15 text-amber-400 border-amber-500/30", Icon: Clock },
  changes_requested: { label: "Changes Requested", cls: "bg-orange-500/15 text-orange-400 border-orange-500/30", Icon: Pencil },
  rejected: { label: "Rejected", cls: "bg-red-500/15 text-red-400 border-red-500/30", Icon: Ban },
};

// Unified status chip used across partner Routes, Content and the admin Review Queue.
// `live` only matters for the approved state (Approved • Live vs Approved • Hidden).
export function StatusChip({ status, live = true, testId }) {
  if (status === "approved") {
    const cls = live
      ? "bg-emerald-500/15 text-emerald-400 border-emerald-500/30"
      : "bg-slate-500/15 text-slate-300 border-slate-500/30";
    const Icon = live ? CheckCircle2 : EyeOff;
    const label = live ? "Approved • Live" : "Approved • Hidden";
    return (
      <span data-testid={testId} className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-xs font-semibold border ${cls}`}>
        <Icon className="w-3.5 h-3.5" />{label}
      </span>
    );
  }
  const s = MAP[status] || MAP.draft;
  const { Icon } = s;
  return (
    <span data-testid={testId} className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-xs font-semibold border ${s.cls}`}>
      <Icon className="w-3.5 h-3.5" />{s.label}
    </span>
  );
}
